import HttpMethod_vue_vue_type_script_setup_true_lang_default from "./HttpMethod.vue.script.js";
/* empty css                         */
import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
//#region src/components/HttpMethod/HttpMethod.vue
var HttpMethod_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HttpMethod_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-86e2b3ea"]]);
//#endregion
export { HttpMethod_default as default };

//# sourceMappingURL=HttpMethod.vue.js.map